import React from 'react';
import { formatDataSourceLabel } from '../../lib/dataSourceLabel';

export function DataSourceIndicator({ dataSource, loading = false }) {
  const label = formatDataSourceLabel(dataSource);
  if (!label) return null;

  return (
    <div
      className="flex justify-end px-1 pt-1"
      aria-live="polite"
      aria-atomic="true"
    >
      <p className="text-[11px] text-slate-400">
        Data source:{' '}
        <span className="font-medium text-slate-500">{label}</span>
        {loading && (
          <span className="ml-1.5 inline-flex items-center gap-1 text-slate-400">
            <span className="h-1 w-1 rounded-full bg-slate-400 animate-pulse" aria-hidden="true" />
            updating
          </span>
        )}
      </p>
    </div>
  );
}
